// Import web components
// We will improve the folder structure as we add components
import '@builder/integrations/components';
import '@builder/item/triggers/components';
import '@builder/item/conditions/components';
import '@builder/user-selector/components';

// Load static resources
import './scss/main.scss';

// Create JS cache object
UncannyAutomator.cache = {
	tokens: {},
};

import {
	createDataOnLoad,
	consoleLogLabel,
	replaceCurlyBraces,
	handleFatalError
}   from './js/common/utilities.js';

import Publish            from './js/publish/publish.js';

import Triggers           from './js/item/triggers.js';
import Actions            from './js/item/actions.js';

import SendFeedback       from './js/send-feedback/send-feedback.js';

import RecipeTitle        from './js/recipe/title';

import Taxonomies         from './js/taxonomies/taxonomies.js';

// Create the data required to render Automator
try {
	createDataOnLoad(() => {
		consoleLogLabel( 'Render the UI', false, { bgColor: '#579f49' });

		// Once ready, render the UI
		new Triggers();
		new Actions();
		new Publish();
		new SendFeedback();
		new RecipeTitle();
		new Taxonomies();
	});
} catch ( error ){
	// Show a modal with data in case the UI couldn't load
	handleFatalError({
		title:   UncannyAutomator.i18n.debugging.uiCantLoad.title,
		warning: UncannyAutomator.i18n.debugging.uiCantLoad.warning,
		content: UncannyAutomator.i18n.debugging.uiCantLoad.content,
		console: error
	});
}

// Remove the "Changes you made may not be saved" WordPress alert
jQuery( document ).ready( () => {
	jQuery( window ).off( 'beforeunload.edit-post', null );
});